export var EntityDataTypes;
(function (EntityDataTypes) {
    EntityDataTypes["Collection"] = "Collection";
    EntityDataTypes["Instance"] = "Instance";
    EntityDataTypes["Primitive"] = "Primitive";
})(EntityDataTypes || (EntityDataTypes = {}));
export var EntityEndpoint;
(function (EntityEndpoint) {
    EntityEndpoint[EntityEndpoint["Default"] = 0] = "Default";
    EntityEndpoint[EntityEndpoint["Central"] = 1] = "Central";
})(EntityEndpoint || (EntityEndpoint = {}));
export const knownEntityTypes = {
    Airport: 'Airport',
    AirportMember: 'AirportMember',
    ArgosLog: 'ArgosLog',
    ArgosProduct: 'ArgosProduct',
    AssociationType: 'AssociationType',
    Break: 'Break',
    Bonus: 'Bonus',
    BonusConstraint: 'BonusConstraint',
    PersonBonus: 'PersonBonus',
    BonusEntry: 'BonusEntry',
    CcSalesPoint: 'CcSalesPoint',
    Card: 'Card',
    CardType: 'CardType',
    CcProduct: 'CcProduct',
    Comment: 'Comment',
    Compensation: 'Compensation',
    Conf: 'Conf',
    Configuration: 'Configuration',
    ConfirmationData: 'ConfirmationData',
    ConfirmationUser: 'ConfirmationUser',
    ContractRow: 'ContractRow',
    ContractType: 'ContractType',
    DaylightSavingTime: 'DaylightSavingTime',
    DbVersion: 'DbVersion',
    Department: 'Department',
    DetailedReportAbsenceOrder: 'DetailedReportAbsenceOrder',
    Device: 'Device',
    DeviceDepartment: 'DeviceDepartment',
    Event: 'Event',
    EventBreak: 'EventBreak',
    EventBreakEvent: 'EventBreakEvent',
    EventCalendar: 'EventCalendar',
    EventMeta: 'EventMeta',
    EventMetaType: 'EventMetaType',
    Fingerprint: 'Fingerprint',
    FreeTime: 'FreeTime',
    FormFilter: 'FormFilter',
    FormFilterOwnerType: 'FormFilterOwnerType',
    GraphLine: 'GraphLine',
    Job: 'Job',
    PlannedAbsence: 'PlannedAbsence',
    JobDepartments: 'JobDepartments',
    JobEventCreatorType: 'JobEventCreatorType',
    JobEvents: 'JobEvents',
    JobProfessionAssociation: 'JobProfessionAssociation',
    JobProfile: 'JobProfile',
    JobReplace: 'JobReplace',
    JobSwap: 'JobSwap',
    JobUser: 'JobUser',
    JobUserGroupAssociation: 'JobUserGroupAssociation',
    LawParagraphConf: 'LawParagraphConf',
    MachineTime: 'MachineTime',
    ManufacturingOrderType: 'ManufacturingOrderType',
    Mode: 'Mode',
    Module: 'Module',
    PaymentCode: 'PaymentCode',
    PaymentCodeMoType: 'PaymentCodeMoType',
    PaymentTimeType: 'PaymentTimeType',
    PeriodSurplus: 'PeriodSurplus',
    PlannerRequest: 'PlannerRequest',
    PlannerRequestType: 'PlannerRequestType',
    Product: 'Product',
    Profession: 'Profession',
    Project: 'Project',
    ProjectAssociation: 'ProjectAssociation',
    RecurringType: 'RecurringType',
    Request: 'Request',
    RequestClass: 'RequestClass',
    RequestConfirmationType: 'RequestConfirmationType',
    RequestLine: 'RequestLine',
    RequestStatus: 'RequestStatus',
    RequestStatusType: 'RequestStatusType',
    RequestSubType: 'RequestSubType',
    RequestType: 'RequestType',
    Rights: 'Rights',
    RightsType: 'RightsType',
    ScreenLocation: 'ScreenLocation',
    Skill: 'Skill',
    SkillScale: 'SkillScale',
    SkillScaleLevel: 'SkillScaleLevel',
    SlipTime: 'SlipTime',
    SlipTimeAssociation: 'SlipTimeAssociation',
    TableHistory: 'TableHistory',
    TableHistoryType: 'TableHistoryType',
    TimeRateAssociation: 'TimeRateAssociation',
    TimeRateSystem: 'TimeRateSystem',
    TransferedTime: 'TransferedTime',
    User: 'User',
    UserContract: 'UserContract',
    UserGroup: 'UserGroup',
    UserGroupRights: 'UserGroupRights',
    UserPlanningConfirmation: 'UserPlanningConfirmation',
    UserProfession: 'UserProfession',
    UserSkill: 'UserSkill',
    WorkCenterCode: 'WorkCenterCode',
    WorkDayEvent: 'WorkDayEvent',
    WorkDayEventType: 'WorkDayEventType',
    WorkEffortType: 'WorkEffortType',
    WorkGroup: 'WorkGroup',
    WorkShift: 'WorkShift',
    WorkShiftBreak: 'WorkShiftBreak',
    WorkShiftDepartment: 'WorkShiftDepartment',
    WorkTimeCalculationType: 'WorkTimeCalculationType',
    WorkTimeCalculationTypeAssociation: 'WorkTimeCalculationTypeAssociation',
    WorkTimeCalculationTypeJobs: 'WorkTimeCalculationTypeJobs',
    Worksite: 'Worksite',
    WorksiteUser: 'WorksiteUser',
    CompletedWorkConfirmation: 'CompletedWorkConfirmation',
    CompletedWorkConfirmedLevel: 'CompletedWorkConfirmedLevel'
};
export const knownCentralEntityTypes = {
    Company: 'Company',
    CompanyStatusType: 'CompanyStatusType',
    Configuration: 'Configuration',
    Connection: 'Connection',
    ConnectionType: 'ConnectionType',
    DeviceStatus: 'DeviceStatus',
    ClientApiConfiguration: 'ClientApiConfiguration',
    DeviceStatusAction: 'DeviceStatusAction',
    DeviceType: 'DeviceType',
    DeviceVersion: 'DeviceVersion',
    ErrorBase: 'ErrorBase',
    ErrorTranslation: 'ErrorTranslation',
    Language: 'Language',
    RestrictedClient: 'RestrictedClient',
    Server: 'Server',
    TrackingEvent: 'TrackingEvent',
    TrackingEventTypes: 'TrackingEventTypes',
    TrackingFloorPlan: 'TrackingFloorPlan',
    TrackingLockData: 'TrackingLockData',
    TrackingRoomData: 'TrackingRoomData',
    TransferedTime: 'TransferedTime',
    Translation: 'Translation',
    TranslationBase: 'TranslationBase',
    UserCompany: 'UserCompany',
    Version: 'Version'
};
